module.exports = __webpack_public_path__ + "static/media/wizualizacja-151.d5f480cd.png";